import { createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4615e1a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "map-content-area" }
const _hoisted_3 = {
  ref: "mapContainer",
  id: "map"
}
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = {
  key: 0,
  class: "detour-message"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "(회색 : 기존 경로 / 빨간색 : 우회 경로)", -1 /* HOISTED */))
const _hoisted_7 = { class: "buttons-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode($setup["NavigationBar"], {
      title: $setup.title,
      shouldHideBackButton: true,
      onOnClickClose: $setup.emitOnClickClose
    }, null, 8 /* PROPS */, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, null, 512 /* NEED_PATCH */),
      _createElementVNode("footer", _hoisted_4, [
        ($props.detourPaths.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createElementVNode("p", null, _toDisplayString($props.detourReason) + " 사유로 일부 구간을 우회 중입니다.", 1 /* TEXT */),
              _hoisted_6,
              _createElementVNode("p", null, "우회일시 : " + _toDisplayString($props.detourBeginDtm) + " ~ " + _toDisplayString($props.detourEndDtm), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createVNode($setup["LineInfoDetailHeader"], {
          lineInfo: $props.lineInfo!,
          busStops: $props.busStops ?? [],
          isLinePathExisted: $props.isLinePathExisted,
          isFavoriteLine: $props.isFavoriteLine,
          shouldShowFavoriteBtn: !$props.isBookable,
          selectedTurn: $props.selectedTurn,
          onOnClickDetailBtn: $setup.emitOnClickDetailBtn,
          onOnClickFavoriteBtn: $setup.emitOnClickFavoriteBtn
        }, null, 8 /* PROPS */, ["lineInfo", "busStops", "isLinePathExisted", "isFavoriteLine", "shouldShowFavoriteBtn", "selectedTurn"])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createVNode($setup["MapZoomLevelSetter"], {
        class: "zoom-level-setter",
        zoomLevel: $setup.zoomLevel,
        maxZoomLevel: $setup.MAX_ZOOM_LEVEL,
        minZoomLevel: $setup.MIN_ZOOM_LEVEL,
        onZoomIn: _cache[0] || (_cache[0] = ($event: any) => ($setup.increaseZoomLevel($setup.map))),
        onZoomOut: _cache[1] || (_cache[1] = ($event: any) => ($setup.decreaseZoomLevel($setup.map)))
      }, null, 8 /* PROPS */, ["zoomLevel"]),
      _createElementVNode("button", {
        class: "road-event-btn-wrapper",
        type: "button",
        onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.toggleShowRoadEventListModal(true))),
        "aria-label": "교통정보 보기"
      }, [
        _createVNode($setup["InlineSvg"], {
          class: "img-btn",
          src: require('@/assets/icons/road-event.svg'),
          alt: "교통정보 보기",
          "aria-hidden": "true"
        }, null, 8 /* PROPS */, ["src"])
      ]),
      ($props.shouldShowBusLocations)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            ref: "refreshButton",
            class: "refresh-btn-wrapper",
            type: "button",
            onClick: $setup.emitOnClickRefreshBtn,
            "aria-label": "새로고침"
          }, [
            _createVNode($setup["InlineSvg"], {
              src: require('@/assets/icons/rotate.svg'),
              alt: "새로고침",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src"])
          ], 512 /* NEED_PATCH */))
        : _createCommentVNode("v-if", true),
      ($props.showCurrentLocation)
        ? (_openBlock(), _createElementBlock("button", {
            key: 1,
            class: "gps-btn-wrapper",
            type: "button",
            "aria-label": "내 위치로 이동",
            onClick: $setup.moveMapToCurrentLocation
          }, [
            _createVNode($setup["InlineSvg"], {
              class: "img-gps-btn",
              src: require('@/assets/icons/gps.svg'),
              alt: "내 위치로 이동",
              "aria-hidden": "true"
            }, null, 8 /* PROPS */, ["src"])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _createVNode($setup["PageModal"], {
      shouldShow: $setup.shouldShowRoadEventListModal,
      onBackHandler: () => $setup.toggleShowRoadEventListModal(false)
    }, {
      default: _withCtx(() => [
        _createVNode($setup["RoadEventListModal"], {
          class: "road-event-list-container",
          routeUid: $props.lineInfo?.id ?? '',
          onOnClickClose: _cache[3] || (_cache[3] = ($event: any) => ($setup.toggleShowRoadEventListModal(false)))
        }, null, 8 /* PROPS */, ["routeUid"])
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["shouldShow", "onBackHandler"])
  ]))
}